import { z } from 'zod';
import { getBaseOasisValidationSchema } from '../../oasis';
/**
 *
 * Note: if there's an overlapping error for a particular field this is the order in which they'll be displayed
 * form level
 * section level
 * field level
 * base level: same level as "field", but uses built int zod validations
 */
// eslint-disable-next-line
export const sectionJConsistency = ({ input, ctx, isSection, field }) => {
    const schema = getBaseOasisValidationSchema('e1', 'soc'); // args here doesn't have a purpose
    if (!isSection && !field) {
        // form level
        // eslint-disable-next-line
        const payload = input;
    }
    else if (!field) {
        // section level
        const payload = input;
        // J-consistency-5920 (a) If J0510=[0], then all active items from J0520 through J0530 must equal [^].
        if (payload?.j0510 === '0' && (payload.j0520 || payload?.j0530)) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `-5920 (a) If J0510 = 0, then all items from J0520 through J0530 must be empty.`,
                path: ['j0510'],
            });
        }
        // J-consistency-5920 (b) If J0510=[1,2,3,4,8], then all active items from J0520 through J0530 must not equal [^].
        if (['1', '2', '3', '4', '8'].includes(payload?.j0510 || '')) {
            if (!payload?.j0520) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-5920 (b) If J0510 is 1, 2, 3, 4, or 8, then all items from J0520 through J0530 must NOT be empty.`,
                    path: ['j0520'],
                });
            }
            if (!payload?.j0530) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-5920 (a) If J0510 = 1, 2, 3, 4, or 8, then J0530 must NOT be empty.`,
                    path: ['j0530'],
                });
            }
        }
    }
    else {
        // field level
        if (field === 'm1033') {
            const payload = input;
            // J-consistency-5050 If M1033_HOSP_RISK_NONE_ABOVE is equal to [0], then at least one active item from M1033_HOSP_RISK_HSTRY_FALLS through M1033_HOSP_RISK_OTHR_RISK must equal [1].
            if (payload && !payload.includes('HOSP_RISK_NONE_ABOVE') && !payload.length) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-5050 If 'None of the above' is NOT checked, then at least one item from M1033_HOSP_RISK_HSTRY_FALLS through M1033_HOSP_RISK_OTHR_RISK must be checked.`,
                    path: [],
                });
            }
            // J-consistency-5060 If M1033_HOSP_RISK_NONE_ABOVE is equal to [1], then all active items from M1033_HOSP_RISK_HSTRY_FALLS through M1033_HOSP_RISK_OTHR_RISK must equal [0].
            if (payload && payload.includes('HOSP_RISK_NONE_ABOVE') && payload.length > 1) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-5060 If M1033 = 1, then all items from M1033_HOSP_RISK_HSTRY_FALLS through M1033_HOSP_RISK_OTHR_RISK must NOT be checked.`,
                    path: [],
                });
            }
        }
    }
};
// J-consistency-5920
// (a) If J0510=[0], then all active items from J0520 through J0530 must equal [^].
// (b) If J0510=[1,2,3,4,8], then all active items from J0520 through J0530 must not equal [^].
// J-consistency-5050 If M1033_HOSP_RISK_NONE_ABOVE is equal to [0], then at least one active item from M1033_HOSP_RISK_HSTRY_FALLS through M1033_HOSP_RISK_OTHR_RISK must equal [1].
// J-consistency-5060 If M1033_HOSP_RISK_NONE_ABOVE is equal to [1], then all active items from M1033_HOSP_RISK_HSTRY_FALLS through M1033_HOSP_RISK_OTHR_RISK must equal [0].
